// extracted by mini-css-extract-plugin
module.exports = {"topic-metadata":"topic_topic-metadata__1RBEv","topic-description":"topic_topic-description__1Nt_E","subtopic":"topic_subtopic__1nU0-"};